var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9472 0H7.03812C5.9044 0 4.98534 0.919064 4.98534 2.05279V12.9619C4.98534 14.0956 5.9044 15.0147 7.03812 15.0147H17.9472C19.0809 15.0147 20 14.0956 20 12.9619V2.05279C20 0.919064 19.0809 0 17.9472 0ZM18.2405 12.9619C18.2405 13.1238 18.1092 13.2551 17.9472 13.2551H7.03812C6.87616 13.2551 6.74487 13.1238 6.74487 12.9619V2.05279C6.74487 1.89083 6.87616 1.75953 7.03812 1.75953H17.9472C18.1092 1.75953 18.2405 1.89083 18.2405 2.05279V12.9619ZM2.69795 6.74487H2.05279C1.89083 6.74487 1.75953 6.87616 1.75953 7.03812V17.9472C1.75953 18.1092 1.89083 18.2405 2.05279 18.2405H12.9619C13.1238 18.2405 13.2551 18.1092 13.2551 17.9472V17.2434C13.2551 16.7575 13.649 16.3636 14.1349 16.3636C14.6208 16.3636 15.0147 16.7575 15.0147 17.2434V17.9472C15.0147 19.0809 14.0956 20 12.9619 20H2.05279C0.919064 20 0 19.0809 0 17.9472V7.03812C0 5.9044 0.919064 4.98534 2.05279 4.98534H2.69795C3.18383 4.98534 3.57771 5.37922 3.57771 5.8651C3.57771 6.35098 3.18383 6.74487 2.69795 6.74487Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c2b33d44f1d69ffb03e0776ad905b8fb.svg";
export { ForwardRef as ReactComponent };